import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PaymentLogos } from "@/components/PaymentLogos";
import { Download, Globe } from "lucide-react";

const COLS = [
  { title: "SHOP NOW", links: [["About", "/community"], ["Community", "/community"], ["Get the App", "/get-app"], ["Careers", "/careers"], ["Pay a Bill", "/pay"], ["Support", "/support"]] },
  { title: "Customer Service", links: [["Help Center", "/support"], ["Returns", "/support?cat=return"], ["Refunds", "/support?cat=return"], ["Delivery", "/support"], ["Track Order", "/track"]] },
  { title: "Sell on SHOP NOW", links: [["Become a Merchant", "/seller"], ["Supplier Registration", "/seller"], ["Seller Resources", "/seller"], ["Merchant Dashboard", "/seller"]] },
  { title: "Delivery", links: [["Become a Driver", "/driver"], ["Haulage & Delivery", "/haulage"], ["Wholesale Quote", "/quote"], ["Delivery Information", "/support"], ["Delivery Tracking", "/track"]] },
  { title: "SHOP+", links: [["Membership", "/shop-plus"], ["Benefits", "/shop-plus"], ["Rewards", "/account"]] },
  { title: "Legal", links: [["Privacy", "/legal?tab=privacy"], ["Terms", "/legal?tab=terms"], ["Cookies", "/legal?tab=cookies"], ["Accessibility", "/legal?tab=accessibility"], ["Seller Terms", "/legal?tab=seller-terms"]] },
];

export function Footer() {
  const [catalogue, setCatalogue] = useState(null);
  const [traffic, setTraffic] = useState(null);
  useEffect(() => {
    api.get("/documents").then(({ data }) => {
      setCatalogue(data.find((d) => d.slug === "catalogue") || null);
    }).catch(() => {});
    api.get("/stats/traffic").then(({ data }) => setTraffic(data)).catch(() => {});
  }, []);
  const catUrl = catalogue ? (catalogue.url.startsWith("http") ? catalogue.url : `${process.env.REACT_APP_BACKEND_URL}${catalogue.url}`) : null;

  return (
    <footer className="sn-ink-bg text-white mt-16 relative overflow-hidden sn-noise">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 relative">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="font-display font-bold text-sm mb-4 text-emerald">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-white/60 hover:text-white transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <img src="/shopnow-logo.png" alt="SHOP NOW — Global Marketplace" className="h-11 w-11 object-contain bg-white rounded-lg p-0.5" />
            <div>
              <div className="font-clash font-bold text-lg">SHOP NOW</div>
              <div className="text-[11px] text-white/50">From Kingston to the World 🌍</div>
            </div>
            {traffic && (
              <div className="ml-3 pl-3 border-l border-white/15 flex items-center gap-1.5 text-white/70" data-testid="site-traffic">
                <Globe size={15} className="text-emerald" />
                <div className="leading-tight">
                  <div className="text-sm font-bold text-white">{Number(traffic.total_visits).toLocaleString()}</div>
                  <div className="text-[10px] text-white/45" data-testid="footer-traffic-label">page views{traffic.since ? ` since ${new Date(traffic.since).toLocaleDateString("en-JM", { month: "short", year: "numeric" })}` : ""}{traffic.unique_sessions ? ` · ${Number(traffic.unique_sessions).toLocaleString()} sessions` : ""} · <span className="text-emerald font-semibold">{traffic.live_visitors} live now</span></div>
                </div>
              </div>
            )}
          </div>
          <div className="flex items-center gap-4">
            {catUrl && (
              <a href={catUrl} target="_blank" rel="noreferrer" download
                className="inline-flex items-center gap-2 bg-[#D8232A] hover:bg-[#b91d23] transition-colors text-white rounded-full px-5 py-2.5 text-sm font-bold" data-testid="footer-catalogue-btn">
                <Download size={15} /> Download Digital Catalogue
              </a>
            )}
            <PaymentLogos size="sm" className="mb-3" />
            <p className="text-xs text-white/40">© {new Date().getFullYear()} SHOP NOW. Global marketplace — Jamaica &amp; beyond.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
